
export const logo = "https://media.licdn.com/dms/image/v2/D560BAQHWfJCP6kHBdA/company-logo_100_100/B56ZdGzHILHUAQ-/0/1749239493822/bettercanvas_logo?e=1755129600&v=beta&t=hEG33d_9MzfxmEN_LghnSEIB7UWc3-RkRwt5lb_P7ls";

export const defaultDarkPreset = {
	"background-0": "#161616",
	"background-1": "#1e1e1e",
	"background-2": "#262626",
	"borders": "#3c3c3c",
	"buttons": "#3c3c3c",
	"links": "#56Caf0",
	"sidebar": "#1e1e1e",
	"sidebar-text": "#f5f5f5",
	"text-0": "#f5f5f5",
	"text-1": "#e2e2e2",
	"text-2": "#ababab",
}

export const defaultLightPreset = {
	"background-0": "#ffffff",
	"background-1": "#f2f4f4",
	"background-2": "#e4e8e8",
	"borders": "#e8eaec",
	"buttons": "#e8eaec",
	"links": "#4a90e2",
	"sidebar": "#e4e8e8",
	"sidebar-text": "#273540",
	"text-0": "#273540",
	"text-1": "#777777",
	"text-2": "#737373",
}